import type { Question } from '@app/src/types/resourceExplorer'
import { Box, Stack, Typography } from '@mui/material'
import React, { useMemo } from 'react'
import { useIntl } from 'react-intl'
import ClassificationRow, { groupClassificationsByRuleType } from './ClassificationRow'

type AnswerClassificationPreviewCardProps = {
  questionAnswerClassifications?: Question['questionAnswerClassificationRules']
  showTitle?: boolean
  points?: {
    isCustom: boolean
    positive: number
    veryPositive: number
    neutral: number
    negative: number
    negativeAdverse: number
  }
}

const AnswerClassificationPreviewCard: React.FC<AnswerClassificationPreviewCardProps> = ({
  questionAnswerClassifications,
  showTitle = true,
  points,
}) => {
  const { formatMessage } = useIntl()
  const { answerClassifications, numberClassifications, optionClassifications } = useMemo(
    () => groupClassificationsByRuleType(questionAnswerClassifications),
    [questionAnswerClassifications],
  )

  return (
    <Stack>
      {showTitle && (
        <Typography variant="subtitle1" paragraph>
          {formatMessage({ id: 'templateBuilder.answerClassifications.title' })}
        </Typography>
      )}

      <Box mt={2}>
        {optionClassifications.map(item => (
          <ClassificationRow
            key={item?.id}
            item={item}
            translationKey="templateBuilder.answerClassifications.optionValue"
            points={points}
          />
        ))}

        {numberClassifications.map(item => (
          <ClassificationRow
            key={item?.id}
            item={item}
            translationKey="templateBuilder.answerClassifications.numberValue"
            points={points}
          />
        ))}

        {answerClassifications.map(item => (
          <ClassificationRow
            key={item?.id}
            item={item}
            translationKey={`templateBuilder.answerClassifications.classificationsValues.${item?.value}`}
            points={points}
          />
        ))}
      </Box>
    </Stack>
  )
}

export default AnswerClassificationPreviewCard
